import {
  Grid2 as Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Tooltip,
  IconButton,
  Snackbar,
  Alert,
  useMediaQuery,
} from "@mui/material";
import { DateTime } from "luxon";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDispatch, useSelector } from "react-redux";
import { useRef, useState } from "react";
import { useEffect } from "react";
import CheckIcon from "@mui/icons-material/Check";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PurchaseExtraCounty from "../popover/promoPopover/PurchaseExtraCounty";
import AddDefaultCardModal from "../popover/promoPopover/AddDefaultCardModal";
import AddPaymentCardModal from "../modals/AddPaymentCardModal";
import axios from "axios";
import {
  refreshDiscountData,
  updateExtraCountyData,
} from "../../store/actions/userActions";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { refreshSubDiscountData } from "../../store/actions/subUserActions";
import {
  loadPermitTemplate,
  setQuickActionAddress,
} from "../../store/actions/dataActions";
import {
  refreshPPDiscountData,
  updatePPExtraCountyData,
} from "../../store/actions/privateProviderActions";
import { getCountyAllowance } from "../../utils/countyAllowance";
import { findCountyByName } from "../../functions/availablePermitForms";

export const getCountyData = (county, nocData, currentTimezone) => {
  let avgCreationTime = "";
  let isAppraiserSuccess = "";
  let checkedDate = "";
  let numCities = 0;
  let numForms = 0;

  const normalizeCountyName = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

  const countiesdata = nocData?.states?.find(
    (state) => state?.state_code === "FL",
  )?.counties;

  const currentCounty = countiesdata?.find(
    (c) => normalizeCountyName(c?.county) === normalizeCountyName(county?.name),
  );

  numCities = currentCounty?.municipality_count;
  numForms = currentCounty?.documents_count;

  const matchingEntry = nocData?.avg_nocs?.find(
    (entry) => entry?._id === county?.name,
  );

  avgCreationTime = matchingEntry
    ? Math.floor(matchingEntry?.avg_second_took)
    : "N/A";

  // APPraiser
  isAppraiserSuccess = currentCounty?.is_success ? true : false;
  const checkedDateTimestamp = currentCounty?.date * 1000;
  const checkedDateMoment = DateTime.fromMillis(checkedDateTimestamp, {
    zone: currentTimezone,
  });

  // Get the current date in the specified timezone
  const currentDate = DateTime.now().setZone(currentTimezone);

  // Check if the date is today in the specified timezone
  const isToday = checkedDateMoment.hasSame(currentDate, "day");

  // Format the date based on whether it's today or not
  if (isToday) {
    checkedDate = checkedDateMoment.toFormat("h:mm a"); // Today, show time only
  } else {
    checkedDate = checkedDateMoment.toFormat("MMM d, h:mm a"); // Other days, show date and time
  }

  return {
    avgCreationTime,
    isAppraiserSuccess,
    checkedDate,
    numCities,
    numForms,
  };
};

const SelectCountyForm = ({
  selectedForm,
  setOpenDefaultModal,
  setFilteredCountiesData,
  setCountiesData,
  favoritesOpen,
  isSmallScreen,
  setSelectedPreForm,
  setOpenDrawer,
  selectedName,
  selectCards,
  type,
  getCurrentTasks,
  filteredCountiesData,
  freeCounty,
  setSelectedPreName,
  monthlyRestart,
  load,
  setStartPermitOpen,
  setAvailableCitiesNum,
  setAvailableFormsNum,
  setDisplayImage,
  setReadyLoad,
  setSelectedCity,
  setSelectedJurId,
  countyLimitSignal,
}) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);
  const { nocData, quickActions } = useSelector((state) => state.nocData);

  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const smDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [tooltipText, setTooltipText] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [isCurrentCard, setIsCurrentCard] = useState("");
  const [currentTimezone, setCurrentTimezone] = useState(
    currentUser?.user?.personal?.[0]?.timezone ||
      currentUser?.subuser?.timezone,
  );
  const [isAnyFavorite, setIsAnyFavorite] = useState(false);

  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const firstRenderRef = useRef();

  //? ADD EXTRA COUNTIES MODALS
  const [addCountyModalOpen, setAddCountyModalOpen] = useState(false);
  const [extraCountyPaymentModalOpen, setExtraCountyPaymentModalOpen] =
    useState(false);
  const [extraCountyTitle, setExtraCountyTitle] = useState("");
  const [defaultCard, setDefaultCard] = useState();
  const [addCountyLoading, setAddCountyLoading] = useState(false);
  const [countyValue, setCountyValue] = useState(0);
  const [paymentCards, setPaymentCards] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [snackOpen, setSnackOpen] = useState(false);
  const countyAllowance = getCountyAllowance(
    currentUser,
    nocData?.total_counties || freeCounty,
  );

  const canHydrateQuickActions =
    typeof setDisplayImage === "function" &&
    typeof setSelectedPreForm === "function" &&
    typeof setSelectedPreName === "function" &&
    typeof setSelectedJurId === "function" &&
    typeof setAvailableCitiesNum === "function" &&
    typeof setAvailableFormsNum === "function" &&
    typeof setReadyLoad === "function" &&
    typeof setStartPermitOpen === "function";

  //? //////////////////////////
  useEffect(() => {
    if (!canHydrateQuickActions) {
      return;
    }

    if (!firstRenderRef?.current && quickActions?.address?.county) {
      const matchedCounty = findCountyByName(
        filteredCountiesData,
        quickActions.address.county,
      );

      if (matchedCounty) {
        firstRenderRef.current = true;
        let numCities = 0;
        let numForms = 0;

        // setSelectedCity(quickActions.address.city); // optional

        const countyData = getCountyData(
          matchedCounty?.name,
          nocData,
          currentTimezone,
        );

        numCities = countyData.numCities;
        numForms = countyData.numForms;

        setDisplayImage(matchedCounty.nocForm);
        setSelectedPreForm(matchedCounty.cover);
        setSelectedPreName(matchedCounty.name);
        setSelectedJurId(matchedCounty.id);
        setAvailableCitiesNum(numCities);
        setAvailableFormsNum(numForms);
        setReadyLoad(true);
        setStartPermitOpen(true);

        setTimeout(() => {
          dispatch(
            setQuickActionAddress({
              county: "",
              city: quickActions.address.city,
            }),
          );
        }, 3000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quickActions?.address?.county]);

  //////////////////////////////

  const snackHandleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
  };

  useEffect(() => {
    if (currentSession === "subUserSession") {
      setCurrentTimezone(currentUser?.subuser?.timezone);
    } else {
      setCurrentTimezone(currentUser?.user?.personal?.[0]?.timezone);
    }
  }, [currentUser, currentSession]);

  useEffect(() => {
    if (countyLimitSignal > 0) {
      setCountyValue(1);
      setAddCountyModalOpen(true);
    }
  }, [countyLimitSignal]);

  useEffect(() => {
    const transformedCards =
      currentUser?.payment_cards?.map((card) => {
        const lastTwo = String(card.exp_year).slice(-2);
        const first = card.exp_month;

        return {
          id: card.id,
          cardNum: "**** **** **** " + card.last4,
          cardName: card.name ? card.name : card.card_holder,
          expires:
            (first < 10 ? "0" + String(first) : String(first)) + "/" + lastTwo,
          default: card.default,
        };
      }) || []; // Ensure we default to an empty array if no cards exist

    setPaymentCards(transformedCards);

    // Find the default card from the transformed cards
    const foundDefaultCard = transformedCards.find((card) => card.default);

    // Save the default card in the state, if it exists
    setDefaultCard(foundDefaultCard || null); // Set null if no default card is found
  }, [currentUser?.payment_cards]);

  useEffect(() => {
    const checkFavoriteStatus = () => {
      const anyFavorite = getCurrentTasks(
        sortTasksByName(filteredCountiesData),
      ).some((county) => isFavorite(county));
      setIsAnyFavorite(anyFavorite);
    };

    checkFavoriteStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredCountiesData]);

  const isFavorite = (county) => {
    const favorites = JSON.parse(localStorage.getItem("favorites")) || [];
    return favorites.some((favorite) => favorite.name === county.name);
  };

  const handleAddToFavorites = (county) => {
    // Get the existing favorites from local storage or initialize an empty array
    const existingFavorites =
      JSON.parse(localStorage.getItem("favorites")) || [];

    // Check if the county is already in the favorites
    const existingIndex = existingFavorites.findIndex(
      (favorite) => favorite.name === county.name,
    );

    if (type === "create-noc") {
      if (existingIndex === -1) {
        // Add the county to the favorites array
        existingFavorites.push(county);
      } else {
        // Remove the county from the favorites array
        existingFavorites.splice(existingIndex, 1);
      }

      // Save the updated favorites array to local storage
      localStorage.setItem("favorites", JSON.stringify(existingFavorites));

      // Create a deep copy of filteredCountiesData to update the buttonText immutably
      const updatedFilteredCountiesData = filteredCountiesData.map((item) =>
        item.name === county.name
          ? { ...item, buttonText: existingIndex === -1 ? "Added" : "Add" }
          : item,
      );

      // Update the state to reflect the changes
      setFilteredCountiesData(updatedFilteredCountiesData);

      if (favoritesOpen) {
        setCountiesData(existingFavorites);
        setFilteredCountiesData(existingFavorites);
      }
    }
  };
  const handleCardAction = (name, form, isDisabledCard, jurisdiction_id) => {
    if (type === "create-noc") {
      const isWarning = currentUser.user.selectedCountiesNOC.some((noc) => {
        return (
          noc.name === name &&
          ((currentUser?.subuser &&
            noc.added_email !== currentUser?.subuser?.email &&
            !noc?.saved) ||
            (!currentUser?.subuser &&
              noc.added_email !== currentUser?.user?.email &&
              !noc?.saved))
        );
      });

      if (
        monthlyRestart &&
        countyAllowance - selectedName.length <= 0 &&
        !selectedName.includes(name)
      ) {
        return;
        // } else if (selectedName.includes(name)) {
        //   selectCards(name, form);
      } else {
        setSelectedPreName(name);
        setSelectedJurId(jurisdiction_id);
        setSelectedPreForm(form);
        if (!isWarning) {
          setOpenDrawer(true);
        } else {
          setOpenDefaultModal(true);
        }
      }

      return;
    }

    const selectedCounty = selectedForm?.find(
      (county) => county?.name === name,
    );
    const isLocked = Boolean(selectedCounty?.locked);

    if (isDisabledCard && type === "welcome" && isLocked === false) {
      // Set the tooltip text
      setTooltipText(
        "Modifying this county is not possible, as another member within your organization has made recent changes to it.",
      );
      setIsCurrentCard(name);
      // Show the tooltip
      setShowTooltip(true);

      // Hide the tooltip after 2 seconds
      setTimeout(() => {
        setShowTooltip(false);
      }, 4000);
      return;
    } else if (type === "welcome" && isLocked === true) {
      // Set the tooltip text
      setTooltipText(
        "Modifications for this county are restricted because it has already been used.",
      );
      setIsCurrentCard(name);
      // Show the tooltip
      setShowTooltip(true);

      // Hide the tooltip after 2 seconds
      setTimeout(() => {
        setShowTooltip(false);
      }, 4000);
      return;
    }
    if (type === "welcome") {
      if (
        countyAllowance - selectedName.length <= 0 &&
        !selectedName.includes(name)
      ) {
        if (
          currentUser?.user?.expired === true ||
          currentUser?.user?.cancellation_time ||
          currentUser?.subuser
        ) {
          return;
        } else {
          //? ADDITIONAL COUNTY MODAL
          setAddCountyModalOpen(true);
          //? ///////////////////////
        }
      } else {
        selectCards(name, jurisdiction_id);
      }
    }
  };

  const handleAddCounty = async () => {
    try {
      setAddCountyLoading(true);
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/stripe/add-subscription-county`,
        {
          currentSession: currentSession,
          num_county: countyValue,
        },
        { withCredentials: true },
      );

      if (resp.data.success) {
        if (currentSession === "privateProviderSession") {
          await dispatch(updatePPExtraCountyData(resp?.data?.data));
        } else {
          await dispatch(updateExtraCountyData(resp?.data?.data));
        }

        if (resp?.data?.discount) {
          if (currentSession === "privateProviderSession") {
            await dispatch(refreshPPDiscountData(resp?.data?.discount));
          } else if (currentSession === "subUserSession") {
            await dispatch(refreshSubDiscountData(resp?.data?.discount));
          } else {
            await dispatch(refreshDiscountData(resp?.data?.discount));
          }
        }

        setAddCountyModalOpen(false);
        setCountyValue(0);
        setSnackOpen(true);
      }
    } catch (err) {
    } finally {
      setAddCountyLoading(false);
    }
  };

  const getStyles = (countyName, isDisabledCard) => {
    const selectedCounty = selectedForm?.find(
      (county) => county?.name === countyName,
    );
    const isLocked = Boolean(selectedCounty?.locked);
    const isSelected = Boolean(selectedCounty);
    const baseSmallCard = {
      position: "relative",
      width: "100%",
      minWidth: 0,
      maxWidth: "100%",
      paddingLeft: 1,
      paddingRight: 1,
      minHeight: "9rem",
      boxSizing: "border-box",
      overflow: "hidden",
    };

    const baseLargeCard = {
      position: "relative",
      overflow: "hidden",
      width: "100%",
      minWidth: 0,
      maxWidth: "100%",
      minHeight: "15.9rem",
    };

    if (isLocked) {
      if (smDown) {
        return {
          ...baseSmallCard,
          border: "2px solid #fff",
          backgroundColor: "#c1d7e1",
          "&:hover": {
            backgroundColor: "#c1d7e1", // Set the same background color on hover
          },
          cursor: "not-allowed",
        };
      } else {
        return {
          ...baseLargeCard,
          border: "8px solid #fff",
          backgroundColor: "#c1d7e1",
          "&:hover": {
            backgroundColor: "#c1d7e1", // Set the same background color on hover
          },
          cursor: "not-allowed",
        };
      }
    } else if (isSelected) {
      if (smDown) {
        return {
          cursor: isDisabledCard ? "not-allowed" : load ? "normal" : "pointer",
          ...baseSmallCard,
          border: "2px solid #76A0B9",
          backgroundColor: "#EEF2F6",
        };
      } else {
        return {
          cursor: isDisabledCard ? "not-allowed" : load ? "normal" : "pointer",
          ...baseLargeCard,
          border: "8px solid #76A0B9",
          backgroundColor: "#EEF2F6",
        };
      }
    } else if (type === "create-noc") {
      if (smDown) {
        return {
          ...baseSmallCard,
          border: "2px solid #fff",
          backgroundColor: "#EEF2F6",
        };
      } else {
        return {
          cursor: nocData?.failed_counties?.includes(countyName)
            ? "normal"
            : "pointer",
          ...baseLargeCard,
          border: nocData?.failed_counties?.includes(countyName)
            ? "8px solid #800000"
            : "8px solid #fff",
          backgroundColor: "#EEF2F6",
        };
      }
    } else {
      if (smDown) {
        return {
          ...baseSmallCard,
          border: "2px solid #fff",
          backgroundColor: "#EEF2F6",
        };
      } else {
        return {
          cursor: isDisabledCard ? "not-allowed" : load ? "normal" : "pointer",
          ...baseLargeCard,
          border: "8px solid #fff",
          backgroundColor: "#EEF2F6",
        };
      }
    }
  };

  function getTooltipTitle(county) {
    const selectedCounty = selectedForm?.find(
      (item) => item?.name === county?.name,
    );

    if (!selectedCounty) {
      return "";
    }

    if (currentUser?.subuser) {
      if (selectedCounty.added_email === currentUser.subuser.email) {
        return "The selection made by you.";
      }

      if (selectedCounty.added_email === currentUser?.user?.email) {
        return "The selection made by your administrator.";
      }

      return `The selection made by ${selectedCounty.added_name}.`;
    }

    return selectedCounty.added_email === currentUser?.user?.email
      ? "The selection made by you."
      : `The selection made by ${selectedCounty.added_name}.`;
  }

  function getIsDisabled(county) {
    const selectedCounty = selectedForm?.find(
      (item) => item?.name === county?.name,
    );

    if (!selectedCounty || !currentUser?.subuser) {
      return false;
    }

    return selectedCounty.added_email !== currentUser.subuser.email;
  }

  const sortTasksByName = (tasks) => {
    if (type === "create-noc") {
      return tasks.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    } else {
      return tasks;
    }
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        sx={{
          width: "100%",
          px: 0,
          mx: 0,
          flexWrap: "wrap",
          gap: smDown ? 0.75 : 1.25,
        }}
      >
        {!isAnyFavorite && favoritesOpen && type === "create-noc" ? (
          <Typography variant="h6" color="error">
            No Pinned Counties Found
          </Typography>
        ) : (
          type !== "trial-ended" &&
          getCurrentTasks(sortTasksByName(filteredCountiesData)).map(
            (county, i) => {
              let numCities = 0;
              let numForms = 0;
              let isDisabledCard = getIsDisabled(county);

              if (nocData) {
                const countyData = getCountyData(
                  county,
                  nocData,
                  currentTimezone,
                );

                numCities = countyData.numCities;
                numForms = countyData.numForms;
              }
              const inFavorite = isFavorite(county);

              let buttonText;
              let btnDisabled = false;

              if (type === "create-noc") {
                if (inFavorite && !favoritesOpen) {
                  buttonText = "Added";
                  btnDisabled = true;
                } else if (!inFavorite && !favoritesOpen) {
                  buttonText = "Add";
                  btnDisabled = false;
                } else if (inFavorite && favoritesOpen) {
                  buttonText = "Remove";
                  btnDisabled = false;
                }
              }
              return (
                <Grid
                  key={county.name}
                  size={{ xs: 5.5, xsm: 4.5, sm: 3.2, md: 2.5, lg: 2 }}
                  sx={{ minWidth: 0, mx: { sm: 1 } }}
                >
                  <Card
                    onClick={(e) => {
                      if (
                        load ||
                        nocData?.failed_counties?.includes(county.name)
                      ) {
                        return;
                      } else {
                        if (type === "create-noc") {
                          setDisplayImage(county.nocForm);
                          setSelectedPreForm(county.cover);
                          setSelectedPreName(county.name);
                          setSelectedJurId(county.id);
                          setAvailableCitiesNum(numCities);
                          setAvailableFormsNum(numForms);
                          setReadyLoad(true);
                          setStartPermitOpen(true);
                          dispatch(loadPermitTemplate(county));
                        } else {
                          handleCardAction(
                            county.name,
                            county.cover,
                            isDisabledCard,
                            county.id,
                          );
                        }
                      }
                    }}
                    sx={getStyles(county.name, isDisabledCard)}
                  >
                    {/* Tooltip */}
                    {showTooltip &&
                      type === "welcome" &&
                      isCurrentCard === county.name && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            width: "100%",
                            transform: "translate(-50%, -50%)",
                            background: "#fff",
                            padding: "10px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                          }}
                        >
                          <Typography sx={{ px: 1 }}>{tooltipText}</Typography>
                        </div>
                      )}
                    {selectedForm?.some((item) => item.name === county.name) &&
                      type === "welcome" && (
                        <Tooltip
                          title={getTooltipTitle(county)}
                          placement="top"
                        >
                          <CheckIcon
                            color="primary"
                            sx={{ position: "absolute", right: 5, top: 5 }}
                          />
                        </Tooltip>
                      )}
                    {type === "create-noc" && (
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!btnDisabled) handleAddToFavorites(county);
                        }}
                        sx={{
                          position: "absolute",
                          top: smDown ? 4 : -3,
                          right: smDown ? 4 : -3,
                          zIndex: 20,
                        }}
                      >
                        {buttonText === "Add" ? (
                          <PushPinOutlinedIcon
                            color="error"
                            sx={{ fontSize: 30, transform: "rotate(45deg)" }}
                          />
                        ) : (
                          <PushPinIcon
                            color="error"
                            sx={{ fontSize: 30, transform: "rotate(45deg)" }}
                          />
                        )}
                      </IconButton>
                    )}

                    <CardContent
                      className="bottomCard"
                      sx={
                        isSmallScreen
                          ? { p: 0.5, minHeight: "7.2rem" }
                          : { p: 0 }
                      }
                    >
                      <img
                        alt={county.name}
                        src={county.cover}
                        style={{ width: "100%", height: "auto" }}
                      />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          width: "100%",
                          mb: 1,
                        }}
                      >
                        {nocData?.failed_counties?.includes(county.name) ? (
                          <>
                            <Typography
                              mt={1}
                              variant="h7"
                              // color={isAppraiserSuccess ? "#008000" : "#800000"}
                              sx={{
                                color: "#800000",
                                textAlign: "center",
                                // ml: 1, // Add margin for separation
                                fontWeight: "bold",
                              }}
                            >
                              County Appraiser's website is temporarily
                              unavailable
                            </Typography>
                          </>
                        ) : (
                          <>
                            {" "}
                            <Typography
                              variant="h7"
                              // color={isAppraiserSuccess ? "#008000" : "#800000"}
                              sx={{
                                color: "#004976",
                                textAlign: "center",
                                // ml: 1, // Add margin for separation
                                fontWeight: "bold",
                                fontSize: mdDown ? "0.75rem" : undefined,
                              }}
                            >
                              Municipalities:{" "}
                              <span
                                style={{ fontSize: mdDown ? "16px" : "18px" }}
                              >
                                {numCities}
                              </span>
                            </Typography>
                            <Typography
                              variant="h7"
                              sx={{
                                color: "#004976",
                                textAlign: "center",
                                fontWeight: "bold",
                                fontSize: mdDown ? "0.75rem" : undefined,
                              }}
                            >
                              Total Documents:{" "}
                              <span
                                style={{ fontSize: mdDown ? "16px" : "18px" }}
                              >
                                {numForms}
                              </span>
                            </Typography>{" "}
                          </>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            },
          )
        )}
        <Snackbar
          sx={{ zIndex: 9999, mt: 6, ml: lgUp ? "150px" : undefined }}
          open={snackOpen}
          autoHideDuration={6000}
          onClose={snackHandleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={snackHandleClose}
            severity="success"
            sx={{
              width: "100%",
              backgroundColor: "#388e3c", // Green shade for success
              color: "#fff",
              fontWeight: "bold",
            }}
            iconMapping={{
              success: <CheckCircleIcon sx={{ color: "#fff" }} />, // Changed to success icon
            }}
          >
            Payment Successful. Thank you
          </Alert>
        </Snackbar>
      </Grid>

      <PurchaseExtraCounty
        setPaymentModalOpen={setExtraCountyPaymentModalOpen} // <----- THIS IS THE SELECT BANK CARD MODAL
        open={addCountyModalOpen}
        setOpen={setAddCountyModalOpen}
        setExtraCountyTitle={setExtraCountyTitle}
        defaultCard={defaultCard}
        handleAddCounty={handleAddCounty}
        addCountyLoading={addCountyLoading}
        countyValue={countyValue}
        setCountyValue={setCountyValue}
      />
      <AddDefaultCardModal
        open={extraCountyPaymentModalOpen}
        setOpen={setExtraCountyPaymentModalOpen}
        paymentCards={paymentCards}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        title={extraCountyTitle}
        defaultCard={defaultCard}
        checkDefault={true}
      />
      <AddPaymentCardModal
        stripe={stripe}
        elements={elements}
        CardElement={CardElement}
      />
    </>
  );
};

export default SelectCountyForm;
